import { Alert, Button, Checkbox, Col, notification, Row, Space } from "antd";
import { CustomCard } from "../../../shared/components/CustomCard/CustomCard";
import CustomForm from "../../../shared/components/CustomForm";
import { prestationInputs } from "./PrestationResumeForm";
import {
  roles,
  statusPrestationsValues,
  subStatus,
} from "../../../utils/constants";
import { GrClearOption } from "react-icons/gr";
import SignatureCanvas from "react-signature-canvas";
import { MessageInfo } from "../../../shared/components/MessageInfo/MessageInfo";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import React, { useContext, useEffect, useRef, useState } from "react";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import {
  finishPrestation,
  getPrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import {
  confirmFinishPrestation,
  prestationFinish,
  prestationsFinishSuccess,
} from "../../../shared/components/Modals/modals";
import { FaFileSignature } from "react-icons/fa";
import { LuClipboardSignature } from "react-icons/lu";
import { BsFillSendFill } from "react-icons/bs";
import { http } from "../../../engine/api/http";
import routes from "../../../engine/routes";
import moment from "moment";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";

export const PrestationSigning = ({ toApproved, formDisabledResume }) => {
  const { user } = useContext(UserContext);

  const { isMobile } = useDeviceDetect();
  const [signing, setSigning] = useState(false);

  const { id } = useParams();
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );

  const [disabled] = usePrestationDisabler();

  let canvaRef = useRef(null);

  const [hasSetSignature, setHasSetSignature] = useState(false);
  const [confirmAutorisation, setConfirmAutorisation] = useState(false);
  const [confirmNoSigning, setConfirmNoSigning] = useState(false);
  const [confirmAdmin, setConfrimAdmin] = useState(false);
  const formRef = useRef(null);
  const [width, setWidth] = useState(0);

  const navigate = useNavigate();

  const { status } = prestation;

  const isFinish = [
    statusPrestationsValues.finish,
    statusPrestationsValues.finish_notsigned,
    statusPrestationsValues.finish_permanance,
  ].includes(prestation.status);

  const isCancel = [
    statusPrestationsValues.cancel,
    statusPrestationsValues.cancelClient,
    statusPrestationsValues.cancelInterprete,
    statusPrestationsValues.cancelAvic,
  ].includes(prestation.status);
  const hasExistingSignature = !!prestation?.interventionFinal?.signing;

  const updateWidth = () => {
    const element = document.querySelector("#layout-content");
    if (element) {
      setWidth(element.offsetWidth - 20);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (hasSetSignature && canvaRef.current !== null) {
      updateWidth();
    }
  }, [hasSetSignature, canvaRef.current]);

  useEffect(() => {
    if (
      !hasSetSignature &&
      hasExistingSignature &&
      canvaRef.current !== null
    ) {
      setHasSetSignature(true);
    }
  }, [
    hasExistingSignature,
    canvaRef.current,
    signing,
    hasSetSignature,
  ]);

  const prestationRef = useRef(prestation);

  useEffect(() => {
    prestationRef.current = prestation;
  }, [prestation]);

  const setCanvaImage = (prestationData, widthData) => {
    if (
      canvaRef.current !== null &&
      canvaRef.current.isEmpty() &&
      widthData !== 0
    ) {
      // canvaRef.current.clear();

      canvaRef.current.fromDataURL(
        prestationRef.current.interventionFinal.signing,
        {
          ratio: 1,
          width: widthData,
          height: 200,
        },
      );
    }
  };

  useEffect(() => {
    if (hasSetSignature || isFinish || (isCancel && hasExistingSignature)) {
      setCanvaImage(prestation, width);
    }
  }, [width, hasSetSignature, isFinish, isCancel, hasExistingSignature]);

  // Use useEffect to attach event listeners for window resizing and initial element width
  useEffect(() => {
    // Initial width set
    updateWidth();

    // Update width when the window is resized
    window.addEventListener("resize", updateWidth);

    // Cleanup
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  const signingDisabled = () => {
    if (user.role === roles.interprete) {
      return toApproved.length === 0 && !formDisabledResume();
    }

    return true;
  };

  const saveFinishedPrestation = async data => {
    await dispatch(setPropertiesPrestation(data));
    await dispatch(updatePrestation());
  };

  const onFinishPrestation = async data => {
    confirmFinishPrestation({
      onOk: async () => {
        let base64Image = canvaRef.current.toDataURL();

        data.interventionFinal ??= {};

        data.interventionFinal.signing = base64Image;

        if (confirmAutorisation) {
          data.status = statusPrestationsValues.finish;
          data.subStatus = subStatus.signed;
        }

        if (confirmNoSigning) {
          data.status = statusPrestationsValues.finish;
          data.subStatus = subStatus.not_signed;
        }

        if (confirmAdmin) {
          data.status = statusPrestationsValues.finish;
          data.subStatus = subStatus.permanance;
        }

        data.interventionFinal.finishAt = dayjs().format();

        await dispatch(setPropertiesPrestation(data));
        const result = await dispatch(finishPrestation());
        // const syncBill = await http.post(`/bills/upsertOneBillOnePrestation`, {
        //   prestation: prestation._id,
        // });
        await dispatch(getPrestation(prestation._id));

        // not finished (the error is shown): no confirmation
        if (result.meta.requestStatus !== "fulfilled") {
          return;
        }

        prestationsFinishSuccess({
          onOk: () => {
            navigate(routes.prestations().list.path);
          },
        });
      },
    });
  };

  const renderButtonsSigning = () => {
    const startDate = dayjs(prestation?.intervention?.startDate);
    const today = dayjs();
    // statusPrestationsValues.draft
    // statusPrestationsValues.waiting

    let canRender = false;

    if (
      status === statusPrestationsValues.waiting ||
      status === statusPrestationsValues.draft ||
      isFinish
    ) {
      return null;
    }

    if (user.role === roles.admin || user.role === roles.permanance) {
      canRender = true;
    } else if (user.role === roles.interprete) {
      // interprete
      if (status === statusPrestationsValues.planned) {
        if (today.isAfter(startDate, "day") || today.isSame(startDate, "day")) {
          canRender = true;
        }
      }
    } else {
      // other role cannot
      return null;
    }

    const finishAndSave = () => {
      formRef.current.submit();
    };

    const signingDisabled = () => {
      if (user.role === roles.interprete) {
        return toApproved.length === 0 && !formDisabledResume();
      }

      return true;
    };

    const beforeStart = moment(
      prestation.intervention.startDate,
    ).isSameOrBefore(moment(), "minute");

    const butterTerminerDisabled = () => {
      if (!confirmAutorisation && !confirmNoSigning && !confirmAdmin) {
        return true;
      }
      if (
        beforeStart === false &&
        userHasLevel({
          not: {
            [roles.admin]: "r", //
            [roles.permanance]: "r", //
          },
        })
      ) {
        return true;
      }
    };

    return canRender ? (
      <ActionRoleSpecific
        only={[roles.interprete, roles.admin, roles.permanance]}
      >
        {isCancel ? null : (
          <>
            {signing &&
            beforeStart === false &&
            userHasLevel({
              not: {
                [roles.admin]: "r", //
                [roles.permanance]: "r", //
              },
            }) ? (
              <Col span={24}>
                <Alert
                  message={`Vous ne pouvez pas terminer une prestation qui n'a pas encore commencé.`}
                  type="error"
                  showIcon
                  closable={true}
                />
              </Col>
            ) : null}

            <Col md={12} xs={24}>
              {signing ? (
                <>
                  <Button
                    onClick={finishAndSave}
                    size={"large"}
                    className={"confirmButton"}
                    type={"primary"}
                    disabled={butterTerminerDisabled()}
                    icon={<BsFillSendFill size={20} />}
                  >
                    Terminer la prestation
                  </Button>
                </>
              ) : (
                <Button
                  disabled={!signingDisabled()}
                  onClick={() => setSigning(true)}
                  size={"large"}
                  className={"confirmButton"}
                  type={"primary"}
                  icon={<LuClipboardSignature size={20} />}
                >
                  Signature
                </Button>
              )}
            </Col>
            <Col md={12} xs={24}>
              <Button
                disabled={toApproved.length !== 0}
                onClick={() => {
                  setSigning(false);
                }}
                size={"large"}
                style={{
                  width: "100%",
                }}
                // className={"confirmButton"}
              >
                Annuler
              </Button>
            </Col>
          </>
        )}
      </ActionRoleSpecific>
    ) : null;
  };

  const renderUpdateButtonAdmin = () => {
    return (
      isFinish && (
        <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
          <Col md={12} xs={24}>
            <Button
              disabled={disabled}
              onClick={async () => {
                formRef.current.submit();
              }}
              loading={loading}
              size={"large"}
              className={"confirmButton"}
              type={"primary"}
            >
              Sauvegarder la prestation
            </Button>
          </Col>
        </ActionRoleSpecific>
      )
    );
  };

  return (
    <>
      {signing || isFinish || (isCancel && hasExistingSignature) ? (
        <Col span={24}>
          <CustomCard
            title={"Vérification et signature"}
            openDefault={true}
            loading={loading}
          >
            <CustomForm
              // a newer copy of the booking from the server replaces what the form was opened with
              key={prestation.updatedAt ?? "new"}
              disabled={formDisabledResume() || disabled}
              initialValues={prestation}
              dataSource={prestationInputs(prestation, user)}
              handleSubmit={data => {
                //  "beneficiary.reference"   name: "beneficiary.firstname", name: "beneficiary.lastname",

                // 20-03-24 I've been ask to do this weird alien things
                // Ask OSEO team why.

                let isValid = false;
                if (
                  data.beneficiary.reference !== "" &&
                  data.beneficiary.reference !== undefined
                ) {
                  isValid = true;
                }

                if (
                  (data.beneficiary.firstname !== undefined &&
                    data.beneficiary.firstname !== "" &&
                    data.beneficiary.firstname.length > 0) ||
                  (data.beneficiary.lastname !== undefined &&
                    data.beneficiary.lastname !== "" &&
                    data.beneficiary.lastname.length > 0)
                ) {
                  isValid = true;
                }

                if (isValid) {
                  return isFinish
                    ? saveFinishedPrestation(data)
                    : onFinishPrestation(data);
                } else {
                  notification.error({
                    message:
                      "Entrez au moins la référence ou le nom/prénom du bénéficiaire.",
                  });
                  // a la defense de la bizzaerie on decouvre un truc cool
                  formRef.current.setFields([
                    {
                      name: "beneficiary.firstname",
                      errors: [
                        "Entrez au moins la référence ou le nom/prénom du bénéficiaire.",
                      ],
                    },
                    {
                      name: "beneficiary.lastname",
                      errors: [
                        "Entrez au moins la référence ou le nom/prénom du bénéficiaire.",
                      ],
                    },
                    {
                      name: "beneficiary.reference",
                      errors: [
                        "Entrez au moins la référence ou le nom/prénom du bénéficiaire.",
                      ],
                    },
                  ]);
                }
              }}
              labelCol={24}
              refForm={formRef}
              wrapperCol={24}
              onValuesChange={undefined}
            />
            <Space direction={"vertical"}>
              <Space
                direction={"horizontal"}
                style={{ opacity: isFinish || isCancel ? 0.5 : 1 }}
              >
                <label>Signature de l'intervenant</label>
                {status === statusPrestationsValues.planned && (
                  <Button
                    size={"small"}
                    onClick={() => {
                      canvaRef.current.clear();
                    }}
                    icon={<GrClearOption size={20} />}
                  >
                    Nettoyer
                  </Button>
                )}
              </Space>

              <SignatureCanvas
                disableDrawing={isFinish || isCancel}
                ref={ref => {
                  canvaRef.current = ref;
                  if ((isFinish || isCancel) && ref !== null) {
                    ref.off();
                    const canvas = ref.getCanvas();
                    // canvas.style.pointerEvents = "none";
                  }
                }}
                clearOnResize={false}
                penColor={"black"}
                canvasProps={{
                  width: width - 15,
                  height: 200,
                  className: "sigCanvas",
                }}
              />
            </Space>

            {!isFinish && !isCancel && (
              <>
                <MessageInfo
                  message={
                    "Toute intervention AVIC doit être payée à l'AVIC sur facture. Les paiements ne doivent pas être versés directement aux interprètes communautaires. "
                  }
                />
                <label>
                  <Checkbox
                    size={"large"}
                    checked={confirmAutorisation}
                    onChange={e => {
                      setConfirmAutorisation(e.target.checked);
                      setConfrimAdmin(false);
                      setConfirmNoSigning(false);
                    }}
                  />
                  <span style={{ padding: 15 }}>
                    Je confirme être le-la responsable de l'entretien ayant
                    l'autorisation de signer ce document.
                  </span>
                </label>
                <br />
                <br />
                <label>
                  <Checkbox
                    size={"large"}
                    checked={confirmNoSigning}
                    onChange={e => {
                      setConfirmAutorisation(false);
                      setConfrimAdmin(false);
                      setConfirmNoSigning(e.target.checked);
                      // if (e.target.checked) {
                      //   canvaRef.current.clear();
                      // }
                    }}
                  />
                  <span style={{ padding: 15 }}>
                    Je n’ai pas pu faire signer l’intervenant-e sur place et
                    désire finaliser cette intervention manuellement.
                  </span>
                </label>
                <ActionRoleSpecific only={[roles.permanance, roles.admin]}>
                  <>
                    <br />
                    <br />
                    <label>
                      <Checkbox
                        name={"admin"}
                        size={"large"}
                        checked={confirmAdmin}
                        onChange={e => {
                          setConfirmAutorisation(false);
                          setConfirmNoSigning(false);
                          setConfrimAdmin(e.target.checked);
                          // if (e.target.checked) {
                          //   canvaRef.current.clear();
                          // }
                        }}
                      />
                      <span style={{ padding: 15 }}>
                        (Permanence) Je termine la prestation pour l’interprète.
                      </span>
                    </label>
                  </>
                </ActionRoleSpecific>
              </>
            )}
          </CustomCard>
        </Col>
      ) : null}

      {renderUpdateButtonAdmin()}
      {renderButtonsSigning()}
    </>
  );
};
